import AutocompleteSingleSelectInputNext from '@/buyers/components/AutocompleteSingleSelectInputNext'
import ModalForm from '@/gf/components/ModalForm'
import useMsgs from '@/gf/hooks/useMsgs'
import useToggle from '@/gf/hooks/useToggle'
import ShippingLocationM from '@/gf/modules/ShippingLocation'
import React, { FormEvent } from 'react'
import {
  AllShippingLocationsDocument,
  AllShippingLocationsQuery,
  AllShippingLocationsQueryVariables,
  useEditRfqShippingLocationMutation,
} from '../../_gen/gql'
import useGqlClient from '../../hooks/useGqlClient'

const ShippingLocationModalForm = ({
  rfqId,
  organizationId,
  open,
  onClose,
  onAfterSave,
}: {
  rfqId: string
  organizationId: string | null
  open: boolean
  onClose: () => void
  onAfterSave: () => void
}) => {
  const [_, msgr] = useMsgs()
  const [spinnerLive, spinner] = useToggle()
  const client = useGqlClient()
  const [locationId, setLocationId] = React.useState<string | null>(null)
  const [editShippingLocation] = useEditRfqShippingLocationMutation({ client })

  const submit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    msgr.clear()

    if (!rfqId || !locationId) return

    spinner.on()

    try {
      await editShippingLocation({
        variables: { requestForQuoteId: rfqId, shippingLocationId: locationId },
      })
      msgr.add('Shipping address updated.', 'positive')
      onAfterSave()
    } catch (err) {
      msgr.addUnknownError()
    } finally {
      spinner.off()
    }
  }

  return (
    <ModalForm
      open={open}
      onClose={onClose}
      title="Edit Shipping Address"
      submitButtonDisabled={spinnerLive}
      submitButtonShowSpinner={spinnerLive}
      onSubmit={submit}
    >
      <AutocompleteSingleSelectInputNext<
        AllShippingLocationsQuery,
        AllShippingLocationsQueryVariables,
        AllShippingLocationsQuery['allShippingLocations'][number]
      >
        gqlClient={client}
        query={AllShippingLocationsDocument}
        queryVars={(search) => ({ value: search, organizationId })}
        onChange={(shippingLocation) => setLocationId(shippingLocation?.id ?? null)}
        transformQueryToData={(queryData) => queryData.allShippingLocations}
        transformDatumToOption={(shippingLocation) => ({
          value: shippingLocation?.id ?? '',
          label: shippingLocation ? ShippingLocationM.label(shippingLocation) : '',
        })}
      />
    </ModalForm>
  )
}

export default ShippingLocationModalForm
